import { Dropdown } from '@artprov/design-system'

export default function DroopdownGestion({ setOpenModal, setActionModal }) {
    const handleOnClick = (opcion) => {
        setActionModal(opcion)
        setOpenModal(true)
    }

    return (
        <Dropdown
            textButton="Gestionar solicitud" variant="outline"
            className="ml-auto"
            opcionesDelMenu={
                [
                    { opcion: "Aprobar solicitud", onClick: () => handleOnClick("aceptar") },
                    { opcion: "Rechazar solicitud", onClick: () => handleOnClick("rechazar") },
                ]}
        />
    )
}